/* eslint-disable eqeqeq */
import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { DeleteUser } from "../../../utilities/api/user/user-service";

const initialState = {
    status: "",
    message: ""
}

export const DeleteUserData = createAsyncThunk("DeleteUser/DeleteUserData", (id: string) => DeleteUser(id))

const DeleteUserSlice = createSlice({
    name: "DeleteUser",
    initialState,
    reducers: {
        resetDeleteSlice: () => initialState
    },
    extraReducers: (builder) => {
        builder

            .addCase(DeleteUserData.fulfilled, (state, action: PayloadAction<any>) => {
                if (action.payload.status == "200") {
                    state.status = action.payload.status
                } else {
                    state.status = action.payload.response.status
                    state.message = action.payload.response.data.message
                }
            })

    }
})

export default DeleteUserSlice.reducer
export const { resetDeleteSlice } = DeleteUserSlice.actions